import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import {
  Button,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";

export type CMButtonChangeLanguageProps = {
  /**
   * 言語ラベル
   */
  labelLanguage?: string;

  /**
   * 区切り文字（言語）
   */
  separatorLanguage?: string;

  /**
   * 日本語ラベル
   */
  labelJP?: string;

  /**
   * 区切り文字（言語選択）
   */
  separatorSelectedLanguage?: string;

  /**
   * 英語ラベル
   */
  labelEN?: string;

  /**
   * 選択中言語の判定に使用
   */
  selectedLanguage: "JP" | "EN";

  /**
   * ボタンが押下されたイベントを呼び出し元に返却
   */
  onClick?: () => void;
} & ComponentStyleProps;

/**
 * 言語切り替えボタンを表示するコンポーネント
 */
export const CMButtonChangeLanguage = ({
  labelLanguage = "Language",
  separatorLanguage = ":",
  labelJP = "JP",
  separatorSelectedLanguage = "/",
  labelEN = "EN",
  selectedLanguage = "JP",
  onClick,

  sx,
  ...rest
}: CMButtonChangeLanguageProps) => {
  const styles = useMultiStyleConfig("CMButtonChangeLanguageStyles", {});

  return (
    <Button onClick={onClick} sx={{ ...sx, ...styles.button }} {...rest}>
      <Text sx={styles.text}>{labelLanguage}</Text>
      <Text sx={styles.text}>{separatorLanguage}</Text>
      <Text
        sx={{
          ...styles.labelJPAndEN,
          ...(selectedLanguage === "JP" ? styles.selected : undefined),
        }}
      >
        {labelJP}
      </Text>
      <Text sx={styles.labelJPAndEN}>{separatorSelectedLanguage}</Text>
      <Text
        sx={{
          ...styles.labelJPAndEN,
          ...(selectedLanguage === "EN" ? styles.selected : undefined),
        }}
      >
        {labelEN}
      </Text>
    </Button>
  );
};

export const CMButtonChangeLanguageStyles: ComponentMultiStyleConfig = {
  parts: ["button", "text", "labelJPAndEN", "selected"],
  baseStyle: {
    button: {
      bgColor: "transparent",
      _hover: { bgColor: "transparent" },
    },
    text: {
      color: "gray.500",
      fontFamily: "Inter",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
    },
    labelJPAndEN: {
      color: "gray.500",
      fontFamily: "Inter",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
    },
    selected: { color: "gray.900" },
  },
};
